import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";

const ViewOnboarding = () => {
    const navigate = useNavigate();
    return (
        <>
            <div className="main_title">
                <h1>Onboarding Details</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
                    <button onClick={() => navigate("/manage-vendors")}>
                        Vendor Onboarding
                    </button>{" "}
                    - View
                </p>
            </div>
            <div className="cards">
                <div className="onboarding_view">
                    {/* Header */}
                    <div className="ov_header">
                        <div>
                            <h2>TechGadgets UAE</h2>
                            <p>info@techgadgets.ae</p>
                        </div>
                        <span className="status in_progress">In Progress</span>
                    </div>

                    {/* Progress */}
                    <div className="ov_progress">
                        <p>Onboarding Progress</p>

                        <div className="progress_steps_v2">

                            <div className="step_item completed">
                                <span className="step_icon">
                                    <DescriptionOutlinedIcon />
                                </span>
                                <p className="step_title">Application Review</p>
                                <span className="step_status">Under review · 2 days ago</span>
                            </div>

                            <div className="step_item completed">
                                <span className="step_icon">
                                    <VerifiedUserOutlinedIcon />
                                </span>
                                <p className="step_title">Document Verification</p>
                                <span className="step_status">Verified · 2 days ago</span>
                            </div>

                            <div className="step_item active">
                                <span className="step_icon">
                                    <StorefrontOutlinedIcon />
                                </span>
                                <p className="step_title">Store Setup</p>
                                <span className="step_status">In progress · 2 days ago</span>
                            </div>

                            <div className="step_item">
                                <span className="step_icon">
                                    <SchoolOutlinedIcon />
                                </span>
                                <p className="step_title">Product Training</p>
                                <span className="step_status">Pending</span>
                            </div>

                            <div className="step_item">
                                <span className="step_icon">
                                    <FactCheckOutlinedIcon />
                                </span>
                                <p className="step_title">Quality Check</p>
                                <span className="step_status">Pending</span>
                            </div>

                            <div className="step_item">
                                <span className="step_icon">
                                    <CheckCircleOutlineOutlinedIcon />
                                </span>
                                <p className="step_title">Final Approval</p>
                                <span className="step_status">Pending</span>
                            </div>

                        </div>
                    </div>


                    {/* Meta Cards */}
                    <div className="ov_meta">
                        <div className="meta_card">
                            <p>Current Stage</p>
                            <h4>Document Verification</h4>
                        </div>
                        <div className="meta_card">
                            <p>Assigned To</p>
                            <h4>Mike Chen</h4>
                        </div>
                        <div className="meta_card">
                            <p>Started</p>
                            <h4>12/14/2025</h4>
                        </div>
                        <div className="meta_card">
                            <p>Pending Tasks</p>
                            <h4>2</h4>
                        </div>
                    </div>

                    {/* Notes */}
                    <div className="ov_notes">
                        <p>Notes</p>
                        <span>Waiting for bank verification document</span>
                    </div>

                    {/* Checklist */}
                    <div className="ov_checklist">
                        <p>Checklist Completed</p>

                        <div className="check_item done">Verify tax certificate</div>
                        <div className="check_item">Validate bank account</div>
                        <div className="check_item">Check insurance coverage</div>
                        <div className="check_item">Review certifications</div>
                    </div>

                    {/* Footer */}
                    <div className="ov_footer">
                        <Button className="btn" variant="outlined">Close</Button>
                        <Button className="btn btn_primary">Move to Next Stage</Button>
                    </div>
                </div>

            </div></>
    );
};
export default ViewOnboarding;